import { render, staticRenderFns } from "./SinavEkrani.vue?vue&type=template&id=d373db88&scoped=true&"
import script from "./SinavEkrani.vue?vue&type=script&lang=js&"
export * from "./SinavEkrani.vue?vue&type=script&lang=js&"
import style0 from "./SinavEkrani.vue?vue&type=style&index=0&id=d373db88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d373db88",
  null
  
)

export default component.exports